<template>
    <Dropdown @on-click="active=>$emit('on-select',active)">
        <Button type="primary">
            {{item.title}}
            <Icon type="ios-arrow-down"></Icon>
        </Button>
        <drop-menu :item="item" slot="list" placement="right-start"></drop-menu>
    </Dropdown>
</template>

<script>
import DropMenu from './dropmenu.vue'
export default {
    props:['item'],
    components:{DropMenu},
}
</script>
